import React from 'react';
import { Form } from 'antd';

export function FormDetailsItem({ label, value }) {
  return (
    <Form.Item layout="vertical" label={label}>
      {value}
    </Form.Item>
  );
}
